import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
export const InlineAlert = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {any} [props.as] e.g. "span" or custom React component
 * @param {any} props.children
 * @param {boolean} [props.valid]
 * @param {any} [props.className]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function InlineAlert({
  as,
  children,
  valid,
  className,
  ...props
}, ref) {
  const EL = as || "div";
  const validClasses = "bg-en-gray-800 text-white";
  const invalidClasses = "bg-en-red text-white";

  const validationStyle = () => {
    return valid ? validClasses : invalidClasses;
  };

  const classes = classNames(className);
  const spanClasses = classNames(["inline-block px-16 py-1 rounded text-white w-full lg:w-auto lg:max-w-75w"], validationStyle());
  return /*#__PURE__*/React.createElement(EL, _extends({
    className: classes,
    ref: ref
  }, props), /*#__PURE__*/React.createElement("span", {
    className: spanClasses
  }, children));
});
InlineAlert.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any,
  valid: PropTypes.bool,
  className: PropTypes.string
};